const config = {
    api: "",
    brand: "stech"
};

//API Setup
if (document && document.location.href.indexOf("localhost")>-1 && document.location.hash.indexOf('devsite')>-1) {
    config.api = "http://epp.devsite";
} else if (document && document.location.href.indexOf("localhost")>-1 ){
    config.api = "http://localhost:63510";
    //config.api = "http://internalpayments.devsite";
}

//Brand Setup
if (document.location.href.indexOf("s-tech") > -1) {
    config.brand = "stech";
    document.title = "Make a Payment | S-Tech";
    document.querySelector('meta[name="description"]').setAttribute("content", "Pay your S-Tech renewal online, just have your reference number to hand. You can make a secure payment by card or via BACS.");
} else {
    config.brand = "abg";
    document.title = "Make a Payment | Alan Boswell Group";
    document.querySelector('meta[name="description"]').setAttribute("content", "Pay your Alan Boswell Group renewal online, just have your reference number to hand. You can make a secure payment by card or via BACS.");

}

console.log('brand:', config.brand);

export default config;